<template>
    <div>
        <v-img dark eager height="110" :src="require('@/assets/img/coach_banner.png')">
            <div class="banner-title">
                {{ $t('student.coach_title') }}
            </div>
        </v-img>

        <v-banner style="top: 64px" sticky single-line color="grey darken-3">
            <v-text-field
                :placeholder="$t('student.search_coach')"
                append-icon="mdi-magnify"
                solo flat dense rounded hide-details
                @keydown.enter="$event.target.blur()"
                class="kimsa-elevation"
                v-model="search"
            />
        </v-banner>
        <v-container>
            <v-row dense>
                <v-col cols="12" class="pt-0">
                    <div class="coach-around">
                        {{ $tc('coach.coach', 2) }}
                    </div>
                    <v-divider/>
                </v-col>
                <v-col cols="12" v-if="loading">
                    <loading-spinner/>
                </v-col>
                <v-col cols="12" md="6" lg="4" xl="3" v-for="(coach,i) in coaches" :key="i">
                    <coach-card :coach="coach"/>
                </v-col>
                <v-col cols="12" v-if="pageCount > 0">
                    <kimsa-pagination
                        @page="page = $event - 1"
                        :pageCount="pageCount"
                        :total-visible="isMobile ? 5 : 7"
                    />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>

import {Client, UserIndex} from '@/utils/Algolia'

import {mapState, mapMutations} from 'vuex'
import CoachCard from "@/components/coach/CoachCard";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import KimsaPagination from "@/components/common/KimsaPagination";

export default {
    components: {KimsaPagination, LoadingSpinner, CoachCard},
    data() {
        return {
            loading: false,
            coaches: [],
            search: '',
            page: 0,
            pageCount: 0,
        }
    },
    computed: {
        ...mapState(['filterCoach']),
        isProd() {
            return process.env.NODE_ENV === 'production'
        },
    },
    async mounted() {
        const vm = this
        vm.loading = true
        await vm.loadCoaches()
        vm.loading = false
    },
    methods: {
        ...mapMutations(['setFilterCoach']),
        async loadCoaches() {
            const vm = this
            vm.coaches = []
            let appTeamQuery = '(appTeam!=1) AND '
            await Client.clearCache()
            let response = await UserIndex.search(vm.search, {
                filters: `${vm.isProd ? appTeamQuery : ''}${vm.filterCoach}`,
                hitsPerPage: 12,
                page: vm.page
            })
            vm.pageCount = response.nbPages || 0
            vm.coaches = response.hits
        },

    },
    watch: {
        filterCoach() {
            this.loadCoaches()
        },
        search() {
            this.page = 0
            this.loadCoaches()
        },
        page() {
            this.loadCoaches()
        }
    },
    beforeRouteLeave(to, from, next) {
        const vm = this
        vm.setFilterCoach()
        next()
    }
}
</script>

<style scoped>

.banner-title {
    font-size: 30px;
    line-height: 30px;
    font-weight: 700;
    padding: 12px;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.2);
}

.coach-around {
    margin-top: 15px;
    margin-bottom: 5px;
    font-size: 18px;
}

</style>
